import pollingService from './polling.service';

export default angular.module('app.polling', [])
	.service('pollingService', pollingService).name;
